export const ZOOM_INCREMENT = 0.2;
